import { render, staticRenderFns } from "./NoticeEmailPanel.vue?vue&type=template&id=68c1d515&scoped=true&"
import script from "./NoticeEmailPanel.vue?vue&type=script&lang=js&"
export * from "./NoticeEmailPanel.vue?vue&type=script&lang=js&"
import style0 from "./NoticeEmailPanel.vue?vue&type=style&index=0&id=68c1d515&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c1d515",
  null
  
)

export default component.exports